const buddyConversationIds = new Set<string>();
let sessionConversationId = '';
let buddyAsks = 0;
let openWhenAskStarted = new Set<string>();
let openConversationIds: () => string[] = () => [];

/** Chats already on screen when Buddy starts talking. A reply must not reload those. */
export function setBuddyOpenConversationIds(list: () => string[]) {
  openConversationIds = list;
}

export function resetBuddyConversationTracking() {
  buddyAsks = 0;
  sessionConversationId = '';
  buddyConversationIds.clear();
  openWhenAskStarted = new Set();
}

export function rememberConversationId(id: unknown) {
  if (typeof id !== 'string' || !id) return;
  buddyConversationIds.add(id);
  if (!sessionConversationId) sessionConversationId = id;
}

/** Empty until the first completion reply. Later calls reuse that id. */
export function conversationIdForCompletion() {
  return sessionConversationId;
}

/** Drop the thread so the next reply is only about the new page, not the previous one. */
export function startBuddyConversation() {
  sessionConversationId = '';
}

/**
 * Buddy's completion is temporary, so the server has nothing to load for that id.
 * True when this id belongs to the reply in progress, or arrived while Buddy was asking
 * and was not already an open chat.
 */
export function claimBuddyConversation(id: string | null | undefined): boolean {
  if (!id) return false;
  if (buddyConversationIds.has(id)) return true;
  if (buddyAsks > 0 && !openWhenAskStarted.has(id)) {
    buddyConversationIds.add(id);
    return true;
  }
  return false;
}

export async function runDuringBuddyAsk<T>(work: () => Promise<T> | T): Promise<T> {
  if (buddyAsks === 0) openWhenAskStarted = new Set(openConversationIds());
  buddyAsks += 1;
  try {
    return await work();
  } finally {
    buddyAsks -= 1;
  }
}
